import { Box, Text } from '@chakra-ui/react';
import { CodeBlock } from '../../../components';

export const NewCodeRender = ({ language, selectionProviderId, application }: any) => {
  const recentApp = application ? application : [];
  switch (language) {
    case 'WEB':
      return (
        <Box w="100%" h="100%">
          <Text
            mt="10px"
            mb="2px"
            fontFamily="inter"
            className="small-font"
            fontWeight="bold"
            color="black.600"
          >
            Install the latest version of the SDK
          </Text>
          <CodeBlock
            code={INSTALL_COMMANDS.WEB}
            language="shell"
            canCopy={true}
            className="x-small-font"
            framework=""
          />
          <Box h="fit-content" mt="10px">
            <Text
              mt="10px"
              fontFamily="inter"
              className="small-font"
              fontWeight="bold"
              mb="2px"
              color="black.600"
            >
              Integrate with your project:
            </Text>
            <CodeBlock
              className="x-small-font"
              code={
                getCodeSnippetForProduction(recentApp, selectionProviderId).reactClient
              }
              language="javascript"
              canCopy={true}
              framework=""
            />
          </Box>
        </Box>
      );
    case 'FLUTTER':
      return (
        <Box w="100%" h="100%">
          <Text
            mt="10px"
            fontFamily="inter"
            className="small-font"
            fontWeight="bold"
            mb="2px"
            color="black.600"
          >
            Install the latest version of the SDK
          </Text>
          <CodeBlock
            code={INSTALL_COMMANDS.FLUTTER}
            language="shell"
            canCopy={true}
            className="x-small-font"
            framework=""
          />
          <Box h="fit-content" mt="10px">
            <Text
              mt="10px"
              fontFamily="inter"
              className="small-font"
              fontWeight="bold"
              mb="2px"
              color="black.600"
            >
              Integrate with your project:
            </Text>
            <CodeBlock
              className="x-small-font"
              code={getCodeSnippetForProduction(recentApp, selectionProviderId).flutter}
              language="javascript"
              canCopy={true}
              framework=""
            />
          </Box>
        </Box>
      );
    case 'REACT_NATIVE':
      return (
        <Box w="100%" h="100%">
          <Text
            mt="10px"
            fontFamily="inter"
            className="small-font"
            fontWeight="bold"
            mb="2px"
            color="black.600"
          >
            Install the latest version of the SDK
          </Text>
          <CodeBlock
            code={INSTALL_COMMANDS.REACTNATIVE}
            language="shell"
            canCopy={true}
            className="x-small-font"
            framework=""
          />
          <Box h="fit-content" mt="10px">
            <Text
              mt="10px"
              fontFamily="inter"
              className="small-font"
              fontWeight="bold"
              mb="2px"
              color="black.600"
            >
              Integrate with your project:
            </Text>
            <CodeBlock
              className="x-small-font"
              code={
                getCodeSnippetForProduction(recentApp, selectionProviderId).reactNative
              }
              language="javascript"
              canCopy={true}
              framework=""
            />
          </Box>
        </Box>
      );
    case 'ZK_FETCH':
      return (
        <Box w="100%" h="100%">
          <Text
            mt="10px"
            fontFamily="inter"
            className="small-font"
            fontWeight="bold"
            mb="2px"
            color="black.600"
          >
            Install the latest version of the SDK
          </Text>
          <CodeBlock
            code={INSTALL_COMMANDS.ZK_FETCH}
            language="shell"
            canCopy={true}
            className="x-small-font"
            framework=""
          />
          <Text
            mt="10px"
            fontFamily="inter"
            className="small-font"
            fontWeight="bold"
            mb="2px"
            color="black.600"
          >
            Download the required ZK files
          </Text>
          <CodeBlock
            code={`node node_modules/@reclaimprotocol/zk-symmetric-crypto/lib/scripts/download-files`}
            language="shell"
            canCopy={true}
            className="x-small-font"
            framework=""
          />
          <Box h="fit-content" mt="10px">
            <Text
              mt="10px"
              fontFamily="inter"
              className="small-font"
              fontWeight="bold"
              mb="2px"
              color="black.600"
            >
              Integrate with your project:
            </Text>
            <CodeBlock
              className="x-small-font"
              code={getCodeSnippetForProduction(recentApp, selectionProviderId).zkFetch}
              language="javascript"
              canCopy={true}
              framework=""
            />
          </Box>
        </Box>
      );

    case 'nodeJS':
      return (
        <Box w="100%" h="100%">
          <Text
            mt="10px"
            fontFamily="inter"
            className="small-font"
            fontWeight="bold"
            mb="2px"
            color="black.600"
          >
            Install the latest version of the SDK
          </Text>
          <CodeBlock
            code={INSTALL_COMMANDS.WEB}
            language="shell"
            canCopy={true}
            className="x-small-font"
            framework=""
          />
          <Box h="fit-content" mt="10px">
            <Text
              mt="10px"
              fontFamily="inter"
              className="small-font"
              fontWeight="bold"
              mb="2px"
              color="black.600"
            >
              Integrate with your project:
            </Text>
            <CodeBlock
              className="x-small-font"
              code={
                getCodeSnippetForProduction(recentApp, selectionProviderId).reactClient
              }
              language="javascript"
              canCopy={true}
              framework=""
            />
          </Box>
        </Box>
      );
    default:
      return (
        <CodeBlock
          code="Select a Framework/Library/Chains"
          language="bash"
          canCopy={true}
          framework=""
        />
      );
  }
};
function ObjEntriesToString(obj: any) {
  if (!obj) return '';
  if (Array.isArray(obj)) {
    return obj
      .map((item) => {
        return Object.entries(item)
          .map(([key, value]) => `'${key}':'${value}'`)
          .join(',');
      })
      .join('}, {');
  }
  const result = Object.entries(obj)
    .map(([key, value]) => `'${key}':'${value}'`)
    .join('}, {');
  return result;
}
export const INSTALL_COMMANDS = {
  WEB: 'npm install @reclaimprotocol/js-sdk',
  react: 'npm install @reclaimprotocol/js-sdk',
  reactConnect: 'npm install @reclaimprotocol/reclaim-connect-react ',
  REACTNATIVE: 'npm i @reclaimprotocol/reactnative-sdk',
  FLUTTER: 'flutter pub add reclaim_sdk',
  ZK_FETCH: 'npm i @reclaimprotocol/zk-fetch',
};

export const getCodeSnippetForProduction = (app: any, selectedProviderId: string) => {
  const nodeJS = `// Package import
import { Reclaim } from '@reclaimprotocol/js-sdk';

const getVerificationReq = async () => {
      const reclaimClient = new Reclaim.ProofRequest("${app?.appId}" );
      const providerId = "${selectedProviderId}";
	  const APP_SECRET = "${app?.privateKey}";  // your app secret key.
      
      await reclaimClient.buildProofRequest(providerId)
      reclaimClient.setSignature(
          await Reclaim.generateSignature(
          APP_SECRET
        )
      )
      const {reclaimUrl, statusUrl} = await reclaimClient.createVerificationRequest()
      return {reclaimUrl, statusUrl}
  }
`;
  const reactClient = `
import { useState } from 'react';
import QRCode from 'react-qr-code';
import { ReclaimProofRequest } from '@reclaimprotocol/js-sdk';
 
function ReclaimDemo() {

  // State to store the verification request URL
  const [requestUrl, setRequestUrl] = useState('');
  const [proofs, setProofs] = useState([]);
 
  const getVerificationReq = async () => {

    // Your credentials from the Reclaim Developer Portal
    // Replace these with your actual credentials

    const APP_ID = '${app?.appId}';
    const APP_SECRET = 'YOUR_APPLICATION_SECRET';
    const PROVIDER_ID = '${selectedProviderId}';
 
    // Initialize the Reclaim SDK with your credentials
    const reclaimProofRequest = await ReclaimProofRequest.init(APP_ID, APP_SECRET, PROVIDER_ID);
 
    // Generate the verification request URL
    const requestUrl = await reclaimProofRequest.getRequestUrl();

    console.log('Request URL:', requestUrl);

    setRequestUrl(requestUrl);
 
    // Start listening for proof submissions
    await reclaimProofRequest.startSession({

      // Called when the user successfully completes the verification
      onSuccess: (proofs) => {

        console.log('Verification success', proofs);
        setProofs(proofs);

        // Add your success logic here, such as:
        // - Updating UI to show verification success
        // - Storing verification status
        // - Redirecting to another page
      },
      // Called if there's an error during verification
      onError: (error) => {

        console.error('Verification failed', error);
 
        // Add your error handling logic here, such as:
        // - Showing error message to user
        // - Resetting verification state
        // - Offering retry options
      },
    });
  };
 
  return (
    <>
      <button onClick={getVerificationReq}>Get Verification Request</button>

      {/* Display QR code when URL is available */}

      {requestUrl && (
        <div style={{ margin: '20px 0' }}>
          <QRCode value={requestUrl} />
        </div>
      )}

      {proofs && (
        <div>
          <h2>Verification Successful!</h2>
          <pre>{JSON.stringify(proofs, null, 2)}</pre>
        </div>
      )}
    </>
  );
}
 
export default ReclaimDemo;
`;
  const reactNative = `
import React, { useState, useEffect } from 'react';
import { View, Text, Button, Linking } from 'react-native';
import { ReclaimProofRequest } from '@reclaimprotocol/reactnative-sdk';
 
const APP_ID = '${app?.appId}';
const APP_SECRET = 'YOUR_APPLICATION_SECRET';
const PROVIDER_ID = '${selectedProviderId}';
 
async function initializeReclaim() {
  const reclaimProofRequest = await ReclaimProofRequest.init(APP_ID, APP_SECRET, PROVIDER_ID);
  return reclaimProofRequest;
}
 
async function generateRequestUrl(reclaimProofRequest) {
  const requestUrl = await reclaimProofRequest.getRequestUrl();
  console.log('Request URL:', requestUrl);
  return requestUrl;
}
 
async function startVerificationSession(reclaimProofRequest, onSuccess, onFailure) {
  await reclaimProofRequest.startSession({
    onSuccess: onSuccess,
    onFailure: onFailure,
  });
}

function ReclaimDemo() {
  const [requestUrl, setRequestUrl] = useState('');
  const [status, setStatus] = useState('');
 
  useEffect(() => {
    async function setup() {
      try {
        const reclaimProofRequest = await initializeReclaim();
        const url = await generateRequestUrl(reclaimProofRequest);
        setRequestUrl(url);
        setStatus('Ready to start verification');
 
        await startVerificationSession(
          reclaimProofRequest,
          (proofs) => {
            if (proofs) {
              if (typeof proofs === 'string') {
                // When using a custom callback url, the proof is returned to the callback url and we get a message instead of a proof
                console.log('SDK Message:', proofs);
              } else if (typeof proofs !== 'string') {
                // When using the default callback url, we get a proof object in the response
                console.log('Proof received:', proofs?.claimData.context);
              }
              setStatus('Proof received!');
            }
          },
          (error) => {
            console.error('Verification failed', error);
            setStatus(\`Error: \${ error.message }\`);
          }
        );
} catch (error) {
        console.error('Setup failed', error);
        setStatus(\`Setup failed: \${ error.message } \`);
      }
    }
 
    setup();
  }, []);
 
  const openRequestUrl = () => {
    if (requestUrl) {
      Linking.openURL(requestUrl);
    }
  };
 
  return (
    <View style={{ padding: 20 }}>
      <Text style={{ fontSize: 24, fontWeight: 'bold' }}>Reclaim Demo</Text>
      <Text>Status: {status}</Text>
      {requestUrl && <Button title="Start Verification" onPress={openRequestUrl} />}
    </View>
  );
}
 
export default ReclaimDemo;
 
`;
  const flutter = `
import 'package:flutter/material.dart';
import 'package:reclaim_sdk/reclaim.dart';
import 'package:reclaim_sdk/utils/interfaces.dart';
import 'package:url_launcher/url_launcher.dart';
 
Future<void> main() async {
  WidgetsFlutterBinding.ensureInitialized();
  runApp(MaterialApp(home: ReclaimExample()));
}
 
class ReclaimExample extends StatefulWidget {
  @override
  _ReclaimExampleState createState() => _ReclaimExampleState();
}
 
class _ReclaimExampleState extends State<ReclaimExample> {
  String _status = '';
  String _proofData = '';
 
  Future<void> _startVerificationSession(ReclaimProofRequest request) async {
    await request.startSession(
      onSuccess: _handleProofSuccess,
      onError: _handleProofError,
    );
  }
 
  void _handleProofSuccess(Proof proof) {
    print('Proof received: $proof');
    setState(() {
      _status = 'Proof received!';
      _proofData =
          'Extracted data: \${proof.claimData.context} Full proof: \${proof.toString()}';
    });
  }
 
  void _handleProofError(Exception error) {
    _handleError('Error in proof generation', error);
  }
 
  void _handleError(String message, dynamic error) {
    print('$message: $error');
    setState(() => _status = '$message: \${error.toString()}');
  }
 
  Future<ReclaimProofRequest> _initializeProofRequest() async {
    final reclaimProofRequest = await ReclaimProofRequest.init(
      "${app?.appId}", // Replace with your actual Application ID
      "YOUR_APP_SECRET", // Replace with your actual Application Secret
      "${selectedProviderId}", // Replace with your actual Provider ID
    );
    return reclaimProofRequest;
  }
 
  Future<String> _generateRequestUrl(ReclaimProofRequest request) async {
    final requestUrl = await request.getRequestUrl();
    print('Request URL: $requestUrl');
    return requestUrl;
  }
 
  Future<void> _launchUrl(String url) async {
    if (await canLaunchUrl(Uri.parse(url))) {
      final launched = await launchUrl(
        Uri.parse(url),
        mode: LaunchMode.externalApplication,
      );
      if (launched) {
        setState(() => _status = 'Session started. Waiting for proof...');
      } else {
        throw 'Could not launch $url';
      }
    }
  }
 
  Future<void> startReclaimSession() async {
    try {
      print('Starting Reclaim session');
      final reclaimProofRequest = await _initializeProofRequest();
      final requestUrl = await _generateRequestUrl(reclaimProofRequest);
      await _launchUrl(requestUrl);
      await _startVerificationSession(reclaimProofRequest);
    } catch (error) {
      _handleError('Error starting Reclaim session', error);
    }
  }
 
  @override
  Widget build(BuildContext context) {
    return Scaffold(
      appBar: AppBar(title: const Text('Reclaim SDK Demo')),
      body: Padding(
        padding: const EdgeInsets.all(16.0),
        child: Column(
          mainAxisAlignment: MainAxisAlignment.center,
          crossAxisAlignment: CrossAxisAlignment.stretch,
          children: [
            ElevatedButton(
              onPressed: startReclaimSession,
              child: const Text('Start Reclaim Session'),
            ),
            const SizedBox(height: 20),
            Text(_status, style: const TextStyle(fontWeight: FontWeight.bold)),
            const SizedBox(height: 20),
            if (_proofData.isNotEmpty)
              Expanded(
                child: SingleChildScrollView(
                  child: Text(_proofData),
                ),
              ),
          ],
        ),
      ),
    );
  }
}


`;

  const zkFetch = app?.zkfetchData?.url
    ? `const { ReclaimClient } = require("@reclaimprotocol/zk-fetch");

const client = new ReclaimClient("${app?.appId}", "${app?.privateKey ?? '<YOUR_APP_SECRET>'}");

const publicOptions = {
    method: '${app.zkfetchData.options.method}',
    headers : {${ObjEntriesToString(app.zkfetchData.options.headers)}}
}
const privateOptions = {
	headers: {${ObjEntriesToString(app.zkfetchData.secretOptions.headers)}},
	responseMatches : [{${ObjEntriesToString(app.zkfetchData.secretOptions.responseMatches)}}],
	responseRedactions : [{${ObjEntriesToString(app.zkfetchData.secretOptions.responseRedactions)}}]
}

const proof = await client.zkFetch('${app.zkfetchData.url}',publicOptions, privateOptions)
return proof;`
    : `const { ReclaimClient } = require("@reclaimprotocol/zk-fetch");

const client = new ReclaimClient("${app?.appId}", "${app?.privateKey ?? '<YOUR_APP_SECRET>'}");

const publicOptions = {
    method: 'GET', // Method GET/POST/PUT
    headers: {} 
}
const privateOptions = {
    headers: {}, // Secret headers  
    responseMatches: [{ type: 'regex', value: '(?<data>.*)' }], 
    responseRedactions: [{'regex': '(?<data>.*)'}]
}

const proof = await client.zkFetch('your-url', publicOptions, privateOptions)
return proof;`;
  return {
    //INSTALL_COMMANDS,
    reactNative,
    reactClient,
    nodeJS,
    flutter,
    zkFetch,
  };
};
